import Link from "next/link";

import AddToCart from "./add-to-cart";
import DiscountChip from "../discount-chip";
import ProductPrice from "../product-price";
import ProductTitle from "../product-title";

import { ContentWrapper, ImageWrapper, StyledCard } from "./styles";
import LazyImageCover from "@/components/LazyImageCover";
import DeleteToFavourite from "./delete-to-favourite";

export default function ProductCard4({
  product,
  showAddButton = true,
  showDeleteFavouriteButton = false,
  onChange = null,
  onDelete = null,
  type = "default"
}) {
  const {
    price,
    photo,
    id,
    discount_price,
    name
  } = product;

  return (
    <StyledCard
      sx={{
        display: "flex",
        flexDirection: type == 'default' ? {
          xs: "column",
          sm: "column"
        } : {
          xs: "column",
          sm: "row"
        },
        alignItems: "stretch"
      }}
    >
      <ImageWrapper
        sx={{
          flex: { xs: "0 0 40%", sm: "none" },
          img: { objectFit: "contain" },
          minHeight: { xs: 120, sm: 160 },
        }}
      >
        {/* DISCOUNT PERCENT CHIP IF AVAILABLE */}
        {discount_price > 0 && (
          <DiscountChip discount={100 - (discount_price / price) * 100} />
        )}

        {/* PRODUCT IMAGE / THUMBNAIL */}
        <Link href={`/products/${id}`}>
          <LazyImageCover alt={name} src={photo} width={100} height={100} />
        </Link>
      </ImageWrapper>

      <ContentWrapper
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          p: { xs: 1, sm: 2 }
        }}
      >
        <div className="content">
          <ProductTitle title={name} slug={id} />

          <ProductPrice
            discount={discount_price === 0 ? 0 : ((price - discount_price) / price) * 100}
            price={price}
          />
        </div>

        {showDeleteFavouriteButton && (
          <DeleteToFavourite product={product} refresh={onChange} removeProductFavorites={onDelete} />
        )}

        {showAddButton && <AddToCart product={product} />}
      </ContentWrapper>
    </StyledCard>
  );
}
